import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Button, Modal } from "react-bootstrap";
import { ExclamationTriangleFill } from "react-bootstrap-icons";

export const ErrorModal = ({ title, text, handleClose }) => (
  <Modal show={true} onHide={handleClose} backdrop="static" keyboard={false}>
    <Modal.Header closeButton>
      <Modal.Title className="d-flex">
        <ExclamationTriangleFill className="align-self-center me-2 text-danger" />
        <span>{title}</span>
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>{text}</Modal.Body>
    <Modal.Footer>
      <Button variant="primary" onClick={handleClose}>
        <FormattedMessage id="component.common.modal.button.ok" />
      </Button>
    </Modal.Footer>
  </Modal>
);

ErrorModal.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
};
